import { Pipe, PipeTransform } from '@angular/core';
import { BookingItem } from '../../models/booking-item';
import { BookingItemNamePipe } from './booking-item-name.pipe';
import { DeliveryItem } from '../../models/deliveries/delivery-item';
import { HireItem, Item } from '../../models';

@Pipe({
  name: 'deliveryItemName',
  standalone: true
})
export class DeliveryItemNamePipe implements PipeTransform {
  constructor(private bookingItemNamePipe: BookingItemNamePipe) {}

  transform(deliveryItem: DeliveryItem): string {
    if (deliveryItem.deliverable_item_type === 'bookingItem') {
      return this.bookingItemNamePipe.transform(
        <BookingItem>deliveryItem.deliverable_item
      );
    }

    let hireItemName = '';
    deliveryItem.deliverable_item = <HireItem>deliveryItem.deliverable_item;

    if (deliveryItem.deliverable_item?.quantity) {
      hireItemName += `${deliveryItem.deliverable_item.quantity} x `;
    }

    hireItemName += `${deliveryItem.deliverable_item.item?.code} (${(deliveryItem.deliverable_item.hireable as Item).product?.name})`;

    return hireItemName;
  }
}
